import { API } from '../axios'

export const fhirAPI = async (props: FhirApiProps) => {
	const { url, method, headers, body, eCode, customError } = props
	const baseURL = import.meta.env.VITE_FHIR_URL

	return await API(
		{
			method,
			url: `${baseURL}/${url}`,
			headers,
			body,
			eCode,
			customError
		},
		'fhir'
	)
}
